import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const CropMapDefinitionRoutes: Route = {
    path: 'definition',
    data: { title: 'definition' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'crop',
        },
        {
            path: 'crop',
            loadComponent: () =>
                import('./cropmap-definition-crops/cropmap-definition-crops.component').then(
                    (m) => m.CropmapAdaptedDefinitionCropsComponent
                ),
            data: { title: 'crop' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'country',
            loadComponent: () =>
                import('./cropmap-definition-countries/cropmap-definition-countries.component').then(
                    (m) => m.CropmapAdaptedDefinitionCountriesComponent
                ),
            data: { title: 'country' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'region',
            loadComponent: () =>
                import('./cropmap-definition-regions/cropmap-definition-regions.component').then(
                    (m) => m.CropmapAdaptedDefinitionRegionsComponent
                ),
            data: { title: 'region' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'state',
            loadComponent: () =>
                import('./cropmap-definition-states/cropmap-definition-states.component').then(
                    (m) => m.CropmapAdaptedDefinitionStatesComponent
                ),
            data: { title: 'state' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'city',
            loadComponent: () =>
                import('./cropmap-definition-cities/cropmap-definition-cities.component').then(
                    (m) => m.CropmapAdaptedDefinitionCitiesComponent
                ),
            data: { title: 'city' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'district',
            loadComponent: () =>
                import('./cropmap-definition-districts/cropmap-definition-districts.component').then(
                    (m) => m.CropmapAdaptedDefinitionDistrictsComponent
                ),
            data: { title: 'district' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
    ],
};
